export const dummy: VendingMachine = {
  address: "",
  postalcode: "",
  city: "",
  aesKey: "",
  description: "",
  identifier: { text: "", symbol: "Kreis", color: "#623F99FF" },
  location: { latitude: undefined, longitude: undefined },
  merchant: {
    mid: "ziib_test",
    blowfishKey: "",
    country: "",
    address: "",
    city: "",
    postcode: "",
    vatId: "",
    currency: "",
    customerId: "",
    hmacKeyComputop: "",
    name: "",
    firstfree: false,
    freelimit: 0,
    networks: [],
    permissions: [],
    vendingMachineTypes: [],
    tiptoggle: false,
    purposetoggle: false,
    purpose: "",
    ageVerificationPOSSelection: [],
    twint_id: "",
    authenticationToken: "",
    hmacKeyThirdParty:"",
    timezone: "",
    dimoco_merchant_id: "",
    dimoco_password: ""
  },
  serialNumber: "",
  vendingMachineType: { type: "COFFEE", description: "Kaffee" },
  vmName: "",
  unlocked: false,
  ageVerification: 0,
  compartment: [],
  terminalId: [],
  clientPosId: "1",
  orderId: "",
};
